import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { NGXLogger } from 'ngx-logger';
import { RichiesteService } from '../../../services/richieste.service';
import { Richiesta } from '../../../models/richiesta.model';

@Component({
  selector: 'app-modifica-richiesta',
  templateUrl: './modifica-richiesta.component.html',
  styleUrls: ['./modifica-richiesta.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    DialogModule,
    InputNumberModule,
    ToastModule
  ],
  providers: [MessageService]
})
export class ModificaRichiestaComponent implements OnInit {
  @Input() richiesta: Richiesta | null = null;
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() modificaCompletata = new EventEmitter<void>();

  importoRichiesto: number = 0;
  importoContributo: number = 0;
  modificaInCorso: boolean = false;

  constructor(
    private richiesteService: RichiesteService,
    private messageService: MessageService,
    private logger: NGXLogger
  ) {}

  ngOnInit() {
    if (this.richiesta) {
      this.importoRichiesto = this.richiesta.importoRichiesto || 0;
      this.importoContributo = this.richiesta.importoContributo || 0;
    }
  }

  show(richiesta: Richiesta) {
    this.richiesta = richiesta;
    this.importoRichiesto = richiesta.importoRichiesto || 0;
    this.importoContributo = richiesta.importoContributo || 0;
    this.visible = true;
    this.logger.info(`[MODIFICA RICHIESTA] Mostra modifica richiesta ${richiesta.id} ${richiesta.importoRichiesto} ${richiesta.importoContributo}`);
  }

  hide() {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  salvaModifiche() {
    if (!this.richiesta) return;

    this.modificaInCorso = true;
    this.logger.info(`[MODIFICA RICHIESTA] Salvataggio modifiche per richiesta ${this.richiesta.id}`);

    const richiestaModificata: Richiesta = {
      ...this.richiesta,
      importoRichiesto: this.importoRichiesto,
      importoContributo: this.importoContributo
    };

    this.richiesteService.modificaRichiesta(richiestaModificata).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Modifica richiesta',
          detail: 'La richiesta è stata modificata con successo',
          life: 5000
        });
        this.modificaCompletata.emit();
        this.hide();
      },
      error: (error: any) => {
        this.logger.error('[MODIFICA RICHIESTA] Errore durante il salvataggio:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Si è verificato un errore durante il salvataggio delle modifiche'
        });
      },
      complete: () => {
        this.modificaInCorso = false;
      }
    });
  }
}
